<template>
    <div>
<span class="flex w-full h-full cursor-pointer" @click="popupActive3=true">{{ selected }}</span>
      <div class="demo-alignment">
        <vs-popup classContent="popup-example" title="Group" :active.sync="popupActive3">
          <v-select :options="['bla bla','bla']" v-model="selected" ></v-select>
          <vs-button @click="popupActive3=false" color="primary" type="filled" style="margin-top: 40px">Save</vs-button>
        </vs-popup>
      </div>
    </div>
</template>

<script>
  import vSelect from 'vue-select'
    export default {
        name: "GroupComponent",
      components:{
        'v-select': vSelect,
      },
      data(){
          return{
            selected: '' || ' No Group',
            popupActive3: false,
            selected_sync: 'fafaffaf'
          }
      },
      methods:{

      }
    }
</script>

<style scoped>

</style>
